'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _tslib = require('../_virtual/_tslib.js');
var jsxRuntime = require('react/jsx-runtime');
var formik = require('formik');
var Checkbox = require('./Checkbox/Checkbox.js');
var Combobox = require('./Select/Combobox.js');
var Input = require('./Input/Input.js');
var Label = require('./Label/Label.js');
var Radio = require('./Radio/Radio.js');
var RadioGroup = require('./RadioGroup/RadioGroup.js');
var Select = require('./Select/Select.js');
var Switch = require('./Switch/Switch.js');
var Textarea = require('./Textarea/Textarea.js');

var Form = function (_a) {
    var children = _a.children, props = _tslib.__rest(_a, ["children"]);
    var handleSubmit = formik.useFormikContext().handleSubmit;
    return (jsxRuntime.jsx("form", _tslib.__assign({ noValidate: true, onSubmit: handleSubmit }, props, { children: children })));
};
Form.Combobox = Combobox["default"];
Form.Checkbox = Checkbox["default"];
Form.Radio = Radio["default"];
Form.RadioGroup = RadioGroup["default"];
Form.Select = Select["default"];
Form.Switch = Switch["default"];
Form.Label = Label["default"];
Form.Input = Input["default"];
Form.Textarea = Textarea["default"];

exports["default"] = Form;
//# sourceMappingURL=Form.js.map
